// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"f72e9cda","62":"10d88e4f","343":"4bd1149f","442":"cb287944","567":"4bfd2ccd","796":"e90d566d","820":"106fe50b","965":"5155ae11"}[chunkId] + ".chunk.js";
};